module.exports = __webpack_public_path__ + "b1c79726468c45dac2a5137c9d0548cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/neu/mann-frau-neu.svg
// module id = 138
// module chunks = 1